import sketchRetina from 'marketing-website/media/images/pages/sketch/sketch-retina@2x.jpg';
import sketchPrototyping from 'marketing-website/media/images/pages/sketch/sketch-prototyping@2x.jpg';
import collaborateSketch from 'marketing-website/media/images/pages/sketch/collaborate-sketch@2x.jpg';
import devicesSketch from 'marketing-website/media/images/pages/sketch/devices@2x.png';
import recordSketch from 'marketing-website/media/images/pages/sketch/record@2x.png';
import handoffSketch from 'marketing-website/media/images/pages/sketch/handoff@2x.png';
import embedSketch from 'marketing-website/media/images/pages/sketch/embed-sketch@2x.jpg';

const assets = {
  illustration: {
    alt: 'Sketch',
    src: sketchRetina,
  },
  prototyping: {
    alt: 'Prototyping',
    src: sketchPrototyping,
  },
  collaborate: {
    alt: 'Collaborate',
    src: collaborateSketch,
  },
  devices: {
    alt: 'Mobile',
    src: devicesSketch,
  },
  record: {
    alt: 'Sketch',
    src: recordSketch,
  },
  handoff: {
    alt: 'developer',
    src: handoffSketch,
  },
  embed: {
    alt: 'embed',
    src: embedSketch,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/sketch/assets.js